/** Registers the app shell service worker for PWA install prompts (Chrome/Edge). */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL ?? ''}/sw.js`;
    navigator.serviceWorker.register(swUrl).catch(() => {
      /* ignore */
    });
  });
}
